import { code } from "@spscommerce/utils";

export const SpsListActionBarExamples = {
    basic: {
        label: "Basic",
        examples: {
            basic: {
                template: code`
                <sps-table #table selectable [(selection)]="selection">
                  <sps-thead>
                    <sps-tr>
                      <sps-th controlCell>
                        <sps-checkbox [(ngModel)]="table.allSelected" [indeterminate]="table.partiallySelected">
                        </sps-checkbox>
                      </sps-th>
                      <sps-th>ID</sps-th>
                      <sps-th>Foobar</sps-th>
                    </sps-tr>
                  </sps-thead>
                  <sps-tbody>
                    <sps-tr>
                      <sps-td>123</sps-td>
                      <sps-td>Florp</sps-td>
                    </sps-tr>
                    <sps-tr>
                      <sps-td>234</sps-td>
                      <sps-td>Gllazx</sps-td>
                    </sps-tr>
                    <sps-tr>
                      <sps-td>345</sps-td>
                      <sps-td>Qudlob</sps-td>
                    </sps-tr>
                    <sps-tr>
                      <sps-td>456</sps-td>
                      <sps-td>Ytrtrrt</sps-td>
                    </sps-tr>
                    <sps-tr>
                      <sps-td>567</sps-td>
                      <sps-td>Arvfrus</sps-td>
                    </sps-tr>
                  </sps-tbody>
                </sps-table>
                <sps-list-action-bar [itemsSelected]="selection?.length" (clearSelected)="selection = []">
                  <sps-button-group>
                    <sps-button kind="icon" icon="trash"></sps-button>
                    <sps-button kind="icon" icon="printer"></sps-button>
                    <sps-button kind="icon" icon="download-cloud"></sps-button>
                    <sps-button kind="icon" icon="archive"></sps-button>
                  </sps-button-group>
                </sps-list-action-bar>
                `,
                class: code`
                    class DemoComponent {
                        selection = [2, 3];
                    }
                `
            }
        }
    }
};
